import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import { Card, CardBody, Col, Row, Badge, Button } from "reactstrap"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import moment from "moment-timezone"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { billStatus, messageTitle } from "constants/common"
import { convertUtcToLocal } from "../../helpers/util"
import { getSettingData } from "../../store/settings/actions"
import { getCarParks as onGetCarParks } from "../../store/carpark/actions"
import {
  getBillFormattedErrors as onGetBillFormattedErrors,
  clearMessage,
  resetExportFileData,
  getExportBills,
} from "store/bill/actions"

import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import { isEmpty, reduce, map } from "lodash"
import InvoiceView from "./InvoiceView"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"

const getColor = status => {
  if (status == billStatus[1]) {
    return "warning"
  } else {
    return "success"
  }
}

const sizePerPage = 25;
const BillingPage = props => {
  const dispatch = useDispatch()
  const [bill, setBill] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })

  const {
    billErrors,
    message,
    pagination,
    error,
    settingData,
    carParks,
    file,
  } = useSelector(state => ({
    billErrors: state.bills.billErrors,
    pagination: state.bills.pagination,
    message: state.bills.message,
    error: state.bills.error,
    settingData: state.Settings.settingData,
    carParks: state.carPark.carParkList,
    file: state.carPark.file,
  }))
  const [filterStatus, setFilterStatus] = useState({
    value: "All",
    label: "All",
  })

  const [filterCarpark, setFilterCarpark] = useState({
    value: "All",
    label: "All Primary Locations",
  })

  const [filters, setFilters] = useState({})

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [primaryStations, setPrimaryStations] = useState([])
  const { SearchBar } = Search

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0, // replace later with size(users),
    custom: true,
    totalPages: pagination?.totalPages || 0,
    onPageChange: setCurrentPage,
  }

  const handleViewClick = e => {
    console.log("e", e)
    setBill(e)
    toggle()
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const billListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, bill) => <>{bill._id}</>,
    },
    {
      text: "Bill ID",
      dataField: "billId",
      sort: true,
    },
    {
      text: "Name",
      dataField: "useName",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <>
          <p className="text-muted mb-0">{record?.userId?.userId || ""}</p>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {record?.userId?.name || ""}
            </Link>
          </h5>
        </>
      ),
    },
    {
      text: "Carpark",
      dataField: "carParkTitle",
      sort: true,
      formatter: (cellContent, record) => (
        <>{record?.userId?.primaryStation || ""}</>
      ),
    },
    // {
    //   text: "Role",
    //   dataField: "Role",
    //   sort: true,
    //   formatter: (cellContent, record) => (
    //     <>{record?.userId?.role.roleTitle || ""}</>
    //   ),
    // },
    {
      text: "Pyment Details",
      dataField: "seasonType",
      sort: true,
      formatter: (cellContent, record) => (
        <>{record?.billDesc ? record?.billDesc[0]?.seasonTitle : "" || ""}</>
      ),
    },
    {
      dataField: "status",
      text: "Bill Status",
      sort: true,
      formatter: (cellContent, record) => (
        <Badge className={"bg-" + getColor(record?.status)}>
          {record?.status}
        </Badge>
      ),
    },
    {
      dataField: "billDate",
      text: "Billing Date",
      sort: true,
      formatter: (cellContent, record) => {
        return <>{record ? convertUtcToLocal(record.billDate) : ""}</>
      },
    },
    {
      dataField: "Amount",
      text: "Amount",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record
              ? "SGD " +
                parseFloat(
                  record?.billAmount?.$numberDecimal.toString()
                ).toFixed(2)
              : ""}
          </>
        )
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
          <Link className="text-info" to="#">
            <i
              className="mdi mdi-file-eye font-size-24"
              id="tooltip"
              onClick={() => handleViewClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="View Bill"
            ></i>
          </Link>
        </div>
      ),
    },
  ]

  useMemo(() => {
    dispatch(onGetCarParks({ status: "Available" }))
    // dispatch(onGetBillErrors({ isSucess: false }))
    dispatch(onGetBillFormattedErrors({page: currentPage, size: sizePerPage}))
    dispatch(getSettingData())
  }, []);

  useEffect(() => {
    dispatch(onGetBillFormattedErrors({page: currentPage, size: sizePerPage}));
  }, [currentPage]);

  useEffect(() => {
    if (settingData["cpfProperties"]) {
      const { cpfBuilding } = settingData["cpfProperties"]
      const list = !isEmpty(cpfBuilding) ? cpfBuilding.split(`,`) : []
      setPrimaryStations(list)
    }
  }, [settingData])

  useEffect(() => {
    if (!isEmpty(billErrors) && !!isEdit) {
      setIsEdit(false)
    }
  }, [billErrors])

  useEffect(() => {
    if (file) {
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file])

  useMemo(() => {
    if (message) {
      message == "PDF file content not found." ||
      message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      dispatch(onGetBillFormattedErrors({page: currentPage, size: sizePerPage}))
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  const toggle = () => {
    setModal(!modal)
  }

  var node = useRef()

  // const resetForm = () => {
  //   setBill(null)
  // }

  // const handleFilter = e => {
  //   setFilterStatus(e)
  //   if (e.value == "All") {
  //     dispatch(onGetBillFormattedErrors({...filters, page: currentPage, size: sizePerPage}))
  //   } else {
  //     dispatch(onGetBillFormattedErrors({ ...filters, status: e.value, page: currentPage, size: sizePerPage }))
  //     setFilters({ ...filters, status: e.value })
  //   }
  // }

  // const handleCarparkFilter = e => {
  //   setFilterCarpark(e)
  //   if (e.value == "All") {
  //     dispatch(onGetBillFormattedErrors({ ...filters, carpark: null, page: currentPage, size: sizePerPage }))
  //   } else {
  //     dispatch(onGetBillFormattedErrors({ ...filters, carpark: e.value, page: currentPage, size: sizePerPage }))
  //     setFilters({ ...filters, carpark: e.value })
  //   }
  // }

  // const handleStartDateSearch = value => {
  //   let payload = { ...filters }
  //   if (value && endDate) {
  //     payload = {
  //       ...payload,
  //       startDate: moment(startDate).format("YYYY-MM-DD"),
  //       endDate: moment(value).format("YYYY-MM-DD"),
  //     }
  //     console.log("payload", payload)
  //   }
  //   dispatch(onGetBillFormattedErrors({...payload, page: currentPage, size: sizePerPage}))
  //   setFilters(payload)
  //   setStartDate(value)
  // }

  // const handleEndDateSearch = value => {
  //   let payload = { ...filters }
  //   if (startDate && value) {
  //     payload = {
  //       ...payload,
  //       startDate: moment(startDate).format("YYYY-MM-DD"),
  //       endDate: moment(value).format("YYYY-MM-DD"),
  //     }
  //   }
  //   dispatch(onGetBillFormattedErrors({...payload, page: currentPage, size: sizePerPage}))
  //   setFilters(payload)
  //   setEndDate(value)
  // }

  // const handleReset = () => {
  //   dispatch(onGetBillFormattedErrors({page: currentPage, size: sizePerPage}))
  //   setFilters({})
  //   setEndDate()
  //   setStartDate()
  //   setFilterStatus({
  //     value: "All",
  //     label: "All",
  //   })
  //   setFilterCarpark({
  //     value: "All",
  //     label: "All Primary Locations",
  //   })
  // }

  let stationOptions = map(primaryStations, el => {
    return {
      value: `${el.trim()}`,
      label: `${el.trim()}`,
    }
  })
  stationOptions.unshift({ value: "All", label: "All Primary Locations" })

  const keyField = "_id"
  let totalBill = 0
  map(billErrors || [], el => {
    totalBill =
      totalBill + parseFloat(el?.billAmount?.$numberDecimal.toString())
  })

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Bill Errors | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Bill Errors" breadcrumbItem="Bill Errors" />
          {/* Billing Page List */}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {console.log('billErrors', billErrors)}
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField={keyField}
                    columns={billListColumns}
                    data={billErrors || []}
                  >
                    {({ paginationProps, paginationTableProps }) => {
                      return (
                        <ToolkitProvider
                          keyField={keyField}
                          data={billErrors || []}
                          columns={billListColumns}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-2">
                                {/* <Col sm="2">
                                  <Select
                                    placeholer={"Select status"}
                                    name={"statusType"}
                                    value={filterStatus}
                                    onChange={e => {
                                      handleFilter(e)
                                    }}
                                    options={statusTypeOptions}
                                    classNamePrefix="select2-selection"
                                  />
                                </Col> */}
                                {/* <Col sm="2">
                                  <Select
                                    placeholer={"Select carpark"}
                                    name={"filterCarpark"}
                                    value={filterCarpark}
                                    onChange={e => {
                                      handleCarparkFilter(e)
                                    }}
                                    options={stationOptions}
                                    classNamePrefix="select2-selection"
                                  />
                                </Col> */}
                                {/* <Col sm="2">
                                  <input
                                    className="form-control"
                                    type="date"
                                    defaultValue={startDate}
                                    id="startDate"
                                    name="startDate"
                                    onChange={e =>
                                      handleStartDateSearch(e.target.value)
                                    }
                                    onBlur={e =>
                                      handleStartDateSearch(e.target.value)
                                    }
                                  />
                                </Col> */}
                                {/* <Col sm="2">
                                  <input
                                    className="form-control"
                                    type="date"
                                    defaultValue={endDate}
                                    id="endDate"
                                    name="endDate"
                                    onChange={e =>
                                      handleEndDateSearch(e.target.value)
                                    }
                                    onBlur={e =>
                                      handleEndDateSearch(e.target.value)
                                    }
                                  />
                                </Col> */}
                                {/* <Col sm="1">
                                  <Button
                                    color="primary"
                                    className="font-14 btn-block btn btn-primary"
                                    onClick={handleReset}
                                  >
                                    Reset
                                  </Button>
                                </Col> */}
                                {/* <Col sm="3">
                                  <div
                                    className="text-sm-end"
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    <div
                                      style={{ width: 100 }}
                                      className="me-2"
                                    >
                                      <Select
                                        placeholder={"Select Type"}
                                        name={"File Type"}
                                        value={fileType}
                                        onChange={e => {
                                          handleSelectType(e)
                                        }}
                                        options={fileTypeOptions}
                                        classNamePrefix="select2-selection me-2"
                                      />
                                    </div>
                                    <Button
                                      color="primary"
                                      className="font-16 btn-block btn btn-primary"
                                      onClick={setDownloadType}
                                    >
                                      <i className="bx bx-upload me-1" />
                                      Export
                                    </Button>
                                  </div>
                                </Col> */}
                              </Row>
                              <Row>
                                {/* <Col sm="auto">
                                  <div className="form-control form-floating mb-3">
                                    <div className="position-relative text-end">
                                      SGD {parseFloat(totalBill).toFixed(2)}
                                    </div>
                                  </div>
                                </Col> */}
                                <Col sm="">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      remote
                                      keyField={keyField}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={node}
                                      noDataIndication={emptyDataMessage}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )
                    }}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {modal && (
            <InvoiceView
              modal={modal}
              toggle={toggle}
              bill={bill}
              carparks={carParks}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(BillingPage)
